import React from 'react';
import { Box } from '@chakra-ui/react';
import { VariableSizeList as List } from 'react-window';

/**
 * Table container component
 * Wraps react-window List with header
 * Handles scroll events and provides unified table structure
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.headerComponent - Header component
 * @param {Array} props.data - Data for the list
 * @param {number} props.height - Height of the list
 * @param {Function} props.onScroll - Scroll handler
 * @param {Function} props.itemSize - Function to calculate item size
 * @param {number} props.minWidth - Minimum width for horizontal scroll
 * @param {React.Component} props.rowComponent - Row component to render
 * @param {React.Ref} props.listRef - Ref for the List component
 * @param {React.Ref} props.containerRef - Ref for the outer container
 * @param {string} props.listKey - Key for forcing List re-render
 */
const TableContainer = ({
  headerComponent,
  data,
  height,
  onScroll,
  itemSize,
  minWidth,
  rowComponent,
  listRef,
  containerRef,
  listKey
}) => {
  return (
    <Box flex={1} minH={0} overflowX="auto" overflowY="hidden" position="relative">
      {/* Header */}
      {headerComponent}
      
      {/* List Container */}
      <Box ref={containerRef} minW={`${minWidth}px`} w="100%">
        <List
          key={listKey}
          ref={listRef}
          height={height}
          itemCount={data?.flattenedData?.length || 0}
          itemSize={itemSize}
          itemData={data}
          width="100%"
          overscanCount={5}
          onScroll={onScroll}
          style={{ overflowX: 'hidden', overflowY: 'auto' }}
        >
          {rowComponent}
        </List>
      </Box>
    </Box>
  );
};

export default TableContainer;

